import { render, staticRenderFns } from "./usageManager.vue?vue&type=template&id=2192f83f&scoped=true&"
import script from "./usageManager.vue?vue&type=script&lang=js&"
export * from "./usageManager.vue?vue&type=script&lang=js&"
import style0 from "./usageManager.vue?vue&type=style&index=0&id=2192f83f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192f83f",
  null
  
)

export default component.exports